import React from 'react';
import {t} from "@lingui/macro";
import BukkuTable from "../Table/BukkuTable";

function ModalTable(props) {
    const { content } = props;

    const keys = Object.keys(content);
    // console.log('aaa modalTable', {content, keys});
    const requiredKeys = ["heading", "rows"];
    if (requiredKeys.find(key => !keys.includes(key)))
        return t`An error has occurred`;

    const columns = content.heading.map(text => ({
        key: text,
        dataIndex: text,
        title: text,
        render: text => text,
    }));

    const dataSource = content.rows.map((row, rowIdx) => {
        const obj = {
            id: rowIdx,
        };
        (row || []).forEach((text, columnIdx) => {
            const column = columns[columnIdx];
            obj[column.key] = text;
        });
        return obj;
    });

    return <BukkuTable
        rowKey="id"
        columns={columns}
        dataSource={dataSource}
    />;
}

export default ModalTable;
